import {map} from 'lodash';
import {Fragment, useCallback, useMemo} from 'react';

import {ExternalLink} from 'components/UIKit';
import {isValidLink} from 'utils';

const DIVIDER = ' ';
const NEW_LINE = '\n';
const NEW_LINE_WORD = '<br/>';
const NEW_LINE_REPLACEMENT = `${DIVIDER}${NEW_LINE_WORD}${DIVIDER}`;

type Props = {
    message: string;
    linkClassName?: string;
}

export const FormattedMessage: React.FC<Props> = ({message, linkClassName = 'link'}: Props) => {

    const fixedMessage = useMemo(() =>
        message
            ?.replaceAll(NEW_LINE, NEW_LINE_REPLACEMENT)
            ?.replaceAll('<br />', NEW_LINE_WORD)
    , [message]);
    const words = useMemo(() => fixedMessage.split(DIVIDER).filter(Boolean), [fixedMessage]);
    const wordsLength = useMemo(() => words.length, [words.length]);

    const renderLink = useCallback((link: string) => <ExternalLink className={linkClassName} link={link} />, [linkClassName]);

    const renderWord = useCallback((word: string) => {
        if (isValidLink(word)) {
            return renderLink(word);
        } else if (word === NEW_LINE_WORD) {
            return <br />;
        }
        return word;
    }, [renderLink]);

    return (
        <Fragment>
            {map(words, (word: string, index: number) => (
                <Fragment key={index}>
                    {renderWord(word)}
                    {index + 1 !== wordsLength && ' '}
                </Fragment>
            ))}
        </Fragment>
    );
};